import { v4 as uuidv4 } from 'uuid';

export const generateUUIDv4 = () => uuidv4();
